<mat-form-field
  appearance="outline"
  [matMenuTriggerFor]="menu"
  class="date-range-picker-field pb-0"
>
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    readonly
    value="{{ viewDateRange.start | date: 'MMM dd, yyyy' }} / {{
      viewDateRange.end | date: 'MMM dd, yyyy'
    }}"
  />
  <ng-icon
    matSuffix
    name="HeroCalendar"
    #open
    class="mat-icon mouse-pointer render-options"
    aria-hidden="true"
  ></ng-icon>
</mat-form-field>

<mat-menu #menu="matMenu">
  <div class="pr-4 pb-4" (click)="$event.stopPropagation()">
    <div class="d-flex pb-4">
      <mat-action-list class="pl-4">
        <h2>Select Period</h2>
        <button mat-list-item (click)="_selectLastNDays(7)">Last 7 Days</button>
        <button mat-list-item (click)="_selectLastNDays(30)">
          Last 30 Days
        </button>
        <button mat-list-item (click)="_selectMTD()">Month to Date</button>
        <button mat-list-item (click)="_selectDateByPeriod('months', 1, 1)">
          Last Month
        </button>
        <button mat-list-item (click)="_selectDateByPeriod('months', 3, 1)">
          Last Three Months
        </button>
        <button mat-list-item (click)="_selectCustom()">
          Custom Date Ranges
        </button>
      </mat-action-list>

      <div class="start-date pr-4">
        <mat-calendar
          class="date-range-picker"
          (selectedChange)="_selectStart($event)"
          [maxDate]="selectedDateRange.end"
          [selected]="selectedDateRange"
          #start
        >
        </mat-calendar>
      </div>
      <div class="end-date" [hidden]="isSameMonth">
        <mat-calendar
          class="date-range-picker"
          (selectedChange)="_selectEnd($event)"
          [minDate]="selectedDateRange.start"
          [maxDate]="today"
          [selected]="selectedDateRange"
          #end
        >
        </mat-calendar>
      </div>
    </div>
    <div class="text-right pr-4">
      <button mat-stroked-button (click)="close()" class="mr-4">Cancel</button>
      <button mat-raised-button color="primary" (click)="setDateRanges()">
        Apply
      </button>
    </div>
  </div>
</mat-menu>
